function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.07 16.14C15.622 16.14 16.07 16.588 16.07 17.14C16.07 17.692 15.622 18.14 15.07 18.14H8.93C8.378 18.14 7.93 17.692 7.93 17.14C7.93 16.588 8.378 16.14 8.93 16.14H15.07ZM12 8.06C13.972 8.06 15.57 9.658 15.57 11.63C15.57 13.602 13.972 15.2 12 15.2C10.028 15.2 8.43 13.602 8.43 11.63C8.43 9.658 10.028 8.06 12 8.06ZM12 10.06C11.133 10.06 10.43 10.763 10.43 11.63C10.43 12.497 11.133 13.2 12 13.2C12.867 13.2 13.57 12.497 13.57 11.63C13.57 10.763 12.867 10.06 12 10.06Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.546 2.121C11.361 1.621 12.389 1.621 13.204 2.121C14.019 2.621 14.484 3.537 14.407 4.491L14.406 4.5H18.5C19.908 4.5 21.05 5.642 21.05 7.05V19.58C21.05 20.988 19.908 22.13 18.5 22.13H5.49C4.082 22.13 2.94 20.988 2.94 19.58V7.05C2.94 5.642 4.082 4.5 5.49 4.5L9.344 4.499C9.271 3.597 9.675 2.736 10.398 2.219L10.546 2.121ZM18.5 6.5H5.49C5.186 6.5 4.94 6.746 4.94 7.05V19.58C4.94 19.884 5.186 20.13 5.49 20.13H18.5C18.804 20.13 19.05 19.884 19.05 19.58V7.05C19.05 6.746 18.804 6.5 18.5 6.5ZM12.157 3.826C11.984 3.719 11.766 3.719 11.593 3.826C11.419 3.932 11.32 4.126 11.337 4.329L11.339 4.446L11.336 4.5H12.414C12.409 4.444 12.409 4.387 12.414 4.33V4.243C12.4 4.073 12.306 3.917 12.157 3.826Z",
  fill: "currentColor"
});

function SvgHomeProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeProfile);
export default __webpack_public_path__ + "static/media/home-profile.f9851a40.svg";
export { ForwardRef as ReactComponent };